export const isActive = (state: string | undefined) => {
  return state === 'active';
};
